import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import DashboardLayout from '../../../layouts/DashboardLayout';
import WikiJurisdiction from '../WikiJurisdiction/WikiJurisdiction';
import { RootState } from '../../../redux/root';
import WikiTabs from '../WikiMain/WikiTabs';
import JurisdictionTabs from '../WikiMain/JurisdictionTabs';

const WikiDetails = () => {
  const wikiMode = useSelector((s: RootState) => s.wikiSlice.wikiMode);

  return (
    <DashboardLayout>
      <Wrapper>
        <WikiTabs />
        <SubTabsRow>
          <JurisdictionTabs />
        </SubTabsRow>
        {wikiMode === 'JURI' && <WikiJurisdiction />}
      </Wrapper>
    </DashboardLayout>
  );
};

export default WikiDetails;

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  padding: 16px 20px 0;
  box-sizing: border-box;
`;

const SubTabsRow = styled.div`
  width: calc(33.333% - 2px);
  min-width: 320px;
`;

export const ControlRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  gap: 16px 24px;
  margin-bottom: 16px;

  > * {
    flex: 1 1 220px;
    min-width: 0;
  }
`;

export const BottomControls = styled.div`
  width: 100%;
  height: 30px;
  text-align: center;
  button {
    width: 122px;
  }
`;
